<template>
  <section class="management-section" data-testid="management-decision-focus">
    <ManagementSectionHeader
      :title="$t('UserProjects.management.decisionFocus.title')"
      icon="pi pi-exclamation-triangle"
      icon-danger
    />

    <div
      v-if="items.length === 0"
      class="text-sm text-[var(--color-disabled)] py-4"
      data-testid="management-decision-focus-empty"
    >
      {{ $t('UserProjects.management.decisionFocus.empty') }}
    </div>

    <div v-else class="grid grid-cols-1 md:grid-cols-2 gap-3">
      <article
        v-for="item in items"
        :key="item.id"
        class="management-panel-card p-4"
        :style="{ borderLeft: `4px solid ${escalationBorderColor(item.escalationTier)}` }"
        :data-testid="`management-decision-card-${item.id}`"
      >
        <div class="flex items-center gap-2 mb-2 flex-wrap">
          <span
            class="inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-bold uppercase"
            :style="statusStyle(item.statusLabel)"
          >
            {{ item.statusLabel }}
          </span>
          <span class="text-[11px] text-[var(--color-disabled)] truncate">{{ item.projectName }}</span>
        </div>

        <h3 class="text-sm font-semibold text-[var(--color-dark)] m-0 mb-1.5 leading-snug">
          {{ item.title }}
        </h3>

        <p v-if="item.impact" class="text-xs text-[var(--color-disabled)] m-0 mb-2 leading-relaxed">
          <span class="text-[var(--color-disabled)]">{{ $t('UserProjects.management.decisionFocus.impact') }}:</span>
          {{ item.impact }}
        </p>

        <div class="flex flex-wrap items-center gap-4 text-xs text-[var(--color-disabled)]">
          <span>
            <span class="text-[var(--color-disabled)]">{{ $t('UserProjects.management.decisionFocus.decider') }}:</span>
            <span class="font-medium text-[var(--color-dark)]">{{ item.deciderName }}</span>
          </span>
          <span :class="item.isOverdue ? 'text-[var(--color-error-text)] font-medium' : 'text-[var(--color-dark)]'">
            {{ formatDueLine(item) }}
          </span>
        </div>
      </article>
    </div>

    <button
      type="button"
      class="management-link mt-3"
      data-testid="management-all-decisions"
      @click="$emit('view-all-decisions')"
    >
      → {{ $t('UserProjects.management.decisionFocus.viewAll') }}
    </button>
  </section>
</template>

<script>
import ManagementSectionHeader from '@/components/CustomerApp/UserProjects/ManagementSectionHeader.vue';
import {
  DECISION_STATUS_STYLES,
  escalationBorderColor,
} from '@/utils/managementDisplay';

export default {
  name: 'ManagementDecisionFocusGrid',
  components: { ManagementSectionHeader },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['view-all-decisions'],
  methods: {
    escalationBorderColor,
    statusStyle(statusLabel) {
      return DECISION_STATUS_STYLES[statusLabel] ?? DECISION_STATUS_STYLES.OFFEN;
    },
    formatDueLine(item) {
      const date = this.formatDate(item.dueDate);
      if (item.isOverdue) {
        return `${date} (${this.$t('UserProjects.management.decisionFocus.overdue')})`;
      }
      return date;
    },
    formatDate(value) {
      if (!value) return '—';
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return '—';
      return date.toLocaleDateString(this.$i18n.locale === 'de' ? 'de-DE' : 'en-GB');
    },
  },
};
</script>

<style scoped>
@import './management-section.css';
</style>
